import Icon from '../components/Icon.vue'

Icon.register({"facebook":{"width":1024,"height":1792,"paths":[{"d":"M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/facebook.js
// module id = 271
// module chunks = 0